module.exports = __webpack_public_path__ + "static/img/ruzhu5.22235cf6.png";